import "./career.css";

const JOBS = [
  {
    title: "Wealth Management Associate",
    location: "Ahmedabad",
    type: "Full-time",
  },
  {
    title: "Investment Research Analyst",
    location: "Ahmedabad",
    type: "Full-time",
  },
  {
    title: "Relationship Manager",
    location: "Ahmedabad",
    type: "Full-time",
  },
  {
    title: "Compliance Officer",
    location: "Ahmedabad",
    type: "Full-time",
  },
];

const APPLY_MAIL = "mailto:careers@gpsfinvest.com";

export default function CareerPositions() {
  return (
    <section id="open-positions" className="career-jobs">
      <div className="career-jobs-inner">
        <aside className="career-jobs-aside">
          <span className="career-jobs-icon" aria-hidden="true">
            <i className="fa-solid fa-briefcase" />
          </span>
          <h2>Open Positions</h2>
          <p>Join our talented team and be a part of something meaningful.</p>
        </aside>

        <div className="career-jobs-list">
          {JOBS.map((job) => (
            <article key={job.title} className="career-job-card">
              <h3>{job.title}</h3>
              <div className="career-job-meta">
                <span>
                  <i className="fa-solid fa-location-dot" aria-hidden="true" />
                  {job.location}
                </span>
                <span>
                  <i className="fa-solid fa-briefcase" aria-hidden="true" />
                  {job.type}
                </span>
              </div>
              <a
                href="mailto:info@gpsfinvest.com"
                className="career-job-apply"
                aria-label={`Apply for ${job.title}`}
              >
                Apply Now
                <span aria-hidden="true">→</span>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
